import { render, staticRenderFns } from "./comment-in.vue?vue&type=template&id=f263da78&scoped=true&"
import script from "./comment-in.vue?vue&type=script&lang=js&"
export * from "./comment-in.vue?vue&type=script&lang=js&"
import style0 from "./comment-in.vue?vue&type=style&index=0&id=f263da78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f263da78",
  null
  
)

export default component.exports